export const prepDTPayload = (filtersData) => {
  const appliedFilters = JSON.parse(JSON.stringify(filtersData));

  const outputData = Object.keys(appliedFilters).map((key) => ({
    field_name: key,
    field_values: appliedFilters[key].map((item) => item.value)
  }));

  return outputData;
};
